import ajaxCrud from "./ajaxCrud";
import { endpointAvvenimento } from "../../constants";

export default {
  getAll(cb = null) {
    ajaxCrud.getAll(endpointAvvenimento, cb);
  },

  get(id, cb) {
    ajaxCrud.get(endpointAvvenimento, id, cb);
  },

  update(id, data = {}, cb) {
    ajaxCrud.update(endpointAvvenimento, id, data, cb);
  },

  create(data = {}, cb) {
    ajaxCrud.create(endpointAvvenimento, data, cb);
  },

  delete(id, cb) {
    ajaxCrud.delete(endpointAvvenimento, id, cb);
  },

  massDelete(ids, cb) {
    ajaxCrud.massDelete(endpointAvvenimento, ids, cb);
  },

  massUpdate(rows, cb) {
    ajaxCrud.massUpdate(endpointAvvenimento, rows, cb);
  },
};
